import { App } from '@flipdish/api-client-typescript';
import { get } from 'lodash';
import { createSelector } from 'reselect';

import { TFeatureFlag } from '../ui/FeatureFlag';

type CurrentAppState = ReturnType<typeof selectCurrentAppState>;
const selectCurrentAppState = (state: AppState) => state.currentApp;

export const getIsOwner = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.AppAccessLevel && currentApp.AppAccessLevel.toString() === 'Owner'
      ? true
      : false;
  }
);

export const isFlipdishGlobal = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.AppId && currentApp.AppId.includes('flipdish-global') ? true : false;
  }
);

export const displayStripeFeature = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('enable-stripe-cc') ? true : false;
  }
);

export const isProductBasedMenusEnabled = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('pbm') ? true : false;
  }
);

export const orderCapacityFeature = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('order-capacity') ? true : false;
  }
);

export const editBankAccountFeature = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('edit-bank-account') ? true : false;
  }
);

export const isSubscriptionsBillingEnabled = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('subscriptions') ? true : false;
  }
);

export const showPausedPayouts = createSelector<AppState, CurrentAppState, boolean>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp.Features && currentApp.Features.includes('payouts-paused') ? true : false;
  }
);

export const getSelectedApp = createSelector<AppState, CurrentAppState, CurrentAppState>(
  [selectCurrentAppState],
  (currentApp) => {
    return currentApp;
  }
);

export const createAppSelector = (propertyName, defaultValue) => (state) => {
  return get(state, `currentApp.${propertyName}`, defaultValue);
};

interface IMapCoordinates {
  lat: number;
  lng: number;
}
export const appMapCenterSelector = createSelector<AppState, App, IMapCoordinates>(
  [(state) => state.currentApp],
  (state) => {
    return {
      lat: (state.MapCenter as any).Latitude,
      lng: (state.MapCenter as any).Longitude,
    };
  }
);

const hasFeatureFactory = (featureName: TFeatureFlag) =>
  createSelector<AppState, CurrentAppState, boolean>([selectCurrentAppState], (currentApp) => {
    return currentApp.Features?.includes(featureName) ? true : false;
  });

export const appSelectors = { hasFeatureFactory };
